<app-page-header title="Host Data" description="Look up raw host file data by date, account and buying group."></app-page-header>
<dx-box direction="row" width="100%" height="75">
  <!-- Always declared: a conditional dxi-item shifts dx-box's item/template mapping for
       every item after it (blank buttons, collapsed lookups). Hidden via `visible`. -->
  <dxi-item [ratio]="0" baseSize="150" [visible]="feeds.length > 1">
    <div class="dx-fieldset">
      <div class="dx-fieldset-label">Feed</div>
      <dx-lookup
      [items]="feedOptions"
      valueExpr="value"
      displayExpr="label"
      [value]="feed"
      [showClearButton]="false"
      (onValueChanged)="setFeed($event)"></dx-lookup>
    </div>
  </dxi-item>
  <dxi-item [ratio]="0" baseSize="150">
    <div class="dx-fieldset">
      <div class="dx-fieldset-label">Host File Date</div>
      <dx-lookup
      [items]="fileDates"
      [value]="fileDate"
      (onValueChanged)="setDate($event)"></dx-lookup>
    </div>
    <dxi-validation-rule type="required" message="Buying group code is required"></dxi-validation-rule>
  </dxi-item>
  <dxi-item [ratio]="0" baseSize="150">
    <div class="dx-fieldset">
      <div class="dx-fieldset-label">Account Code</div>
      <dx-lookup
      [items]="accountCodes"
      [value]="accountCode"
      [disabled]="accountLookupDisabled"
      [hint]="accountLookupDisabled ? 'This feed has no account split' : ''"
      (onValueChanged)="setAccountCode($event)"></dx-lookup>
    </div>
  </dxi-item>
  <dxi-item [ratio]="0" baseSize="150">
    <div class="dx-fieldset">
      <div class="button-spacer"></div>
        <dx-button
          stylingMode="contained"
          text="Load"
          type="default"
          [width]="120"
          (onClick)="loadData()"
        ></dx-button>
      </div>
  </dxi-item>
  <dxi-item [ratio]="0" baseSize="150">
    <div class="dx-fieldset">
      <div class="button-spacer"></div>
        <dx-button
          stylingMode="contained"
          text="Rollback"
          type="default"
          [width]="120"
          [disabled]="rollBackDisabled"
          (onClick)="rollBackData()"
        ></dx-button>
      </div>
  </dxi-item>
</dx-box>
<div class="grid">
@if (gridReady) {
<dx-data-grid #rawHostData [ngClass]="{ 'hidden': dataLoading, 'visible': !dataLoading }"
  [dataSource]="dataSource"
  [remoteOperations]="false"
  [allowColumnReordering]="false"
  [rowAlternationEnabled]="true"
  [height]="'100%'"
  [allowColumnResizing]="true"
  [columnResizingMode]="'widget'"
  [showColumnLines]="true"
  [wordWrapEnabled]="true"
  [columnAutoWidth]="true"
  [loadPanel]="{ enabled: false }"
  (onExporting)="onExporting($event)">

  <dxo-state-storing
    [enabled]="true"
    type="localStorage"
    [storageKey]="gridStorageKey"
  ></dxo-state-storing>

  <dxo-sorting mode="multiple"></dxo-sorting>
  <dxo-header-filter [visible]="true"></dxo-header-filter>
  <dxo-export [enabled]="true" [allowExportSelectedData]="false"></dxo-export>
  <dxo-column-chooser
    #columnChooser
    [enabled]="true"
    mode="select"
  ></dxo-column-chooser>

  <dxo-search-panel [visible]="true"></dxo-search-panel>

</dx-data-grid>
}
<dx-load-panel
    #loadPanel
    shadingColor="rgba(0,0,0,0.4)"
    [(visible)]="dataLoading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [hideOnOutsideClick]="false"
  >
  </dx-load-panel>
</div>
